import { defineMessages } from 'react-intl-next';

export const messages: {
    confirmationMessage: {
        defaultMessage: string;
        description: string;
        id: string;
    }; contrastRatioFailMessage: {
        defaultMessage: string;
        description: string;
        id: string;
    }; contrastRatioPassMessage: {
        defaultMessage: string;
        description: string;
        id: string;
    }; errorMessage: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	confirmationMessage: {
		id: 'company-hub.color-picker.color-validation-messages.confirmation-message',
		defaultMessage: 'Color selection added',
		description:
			'Confirmation message for custom palette when current value of color input is successfully elevated to curated palette',
	},
	errorMessage: {
		id: 'company-hub.color-picker.color-validation-messages.error-message',
		defaultMessage: 'Enter a valid color',
		description:
			'Error message for custom palette when current value of color input is invalid or empty',
	},
	contrastRatioPassMessage: {
		id: 'company-hub.color-picker.color-validation-messages.contrast-ratio-pass-message',
		defaultMessage: 'Passes accessibility standards',
		description:
			'Confirmation message for custom palette when current value of color input passes accessibility standards',
	},
	contrastRatioFailMessage: {
		id: 'company-hub.color-picker.color-validation-messages.contrast-ratio-fail-message',
		defaultMessage: 'Does not pass accessibility standards',
		description:
			'Error message for custom palette when current value of color input does not pass accessibility standards',
	},
});
